module.exports = __webpack_public_path__ + "img/contact.c2df9ce7.jpg";